/*
 * @Author: wangyan1
 * @Description:
 * @Date: 2022-04-22 11:41:00
 * @LastEditTime: 2023-12-25 11:07:08
 * @FilePath: /teacher-xkh-web/src/service/groupManage/index-url.js
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 金币-查询机构下学生总积分列表
  getCoinList: `${baseUrl}/coin/findInsStudentTotalCoinsPage`,
  // 查询某个学生扣减明细
  getCoinById: `${baseUrl}/coin/findInsSingleStudentDeductionCoinsPage`,
  // 扣减金币
  deductionCoins: `${baseUrl}/coin/deductionCoins`,
  // 金币-查询机构下所有学生扣减明细
  getAllCoinsPage: `${baseUrl}/coin/findInsStudentDeductionCoinsPage`,
  addCoins: `${baseUrl}/coin/add`
}
